/**
 * Builds a Map of existing contextual node values for IMP forms.
 * Key: contextualNode (imSegment), Value: { impressions, valueToBeLockedAtPackageLevel }
 */
export const computeExistingContextualNodeValues = (
    existingContextualNodes: Array<{
        contextualNode?: string;
        impressionsBooked?: number;
        valueBlockedAtPackageLevel?: number;
    }> | null | undefined,
): Map<string, { impressions: number; valueToBeLockedAtPackageLevel: number }> => {
    const map = new Map<string, { impressions: number; valueToBeLockedAtPackageLevel: number }>();
    if (!existingContextualNodes || existingContextualNodes.length === 0) return map;
    existingContextualNodes.forEach((node) => {
        const imSegment = node.contextualNode || '';
        if (imSegment)
            map.set(imSegment, {
                impressions: node.impressionsBooked || 0,
                valueToBeLockedAtPackageLevel: node.valueBlockedAtPackageLevel || 0,
            });
    });
    return map;
};

/**
 * Extracts the non-contextual percentage from existing contextual nodes for SOV forms.
 * Returns the percentageBooked of the first node, or 0 if none exist.
 */
export const computeExistingNonContextualPercentage = (
    existingContextualNodes: Array<{
        percentageBooked?: number | null;
    }> | null | undefined,
): number => {
    if (!existingContextualNodes || existingContextualNodes.length === 0) return 0;
    return existingContextualNodes[0]?.percentageBooked || 0;
};

/**
 * Builds a Map of existing contextual node percentages for SOV forms.
 * Key: contextualNode, Value: percentageBooked
 */
export const computeExistingContextualNodePercentages = (
    existingContextualNodes: Array<{
        contextualNode?: string;
        percentageBooked?: number | null;
    }> | null | undefined,
): Map<string, number> => {
    const map = new Map<string, number>();
    if (!existingContextualNodes || existingContextualNodes.length === 0) return map;
    existingContextualNodes.forEach((node) => {
        if (node.contextualNode) {
            map.set(node.contextualNode, node.percentageBooked || 0);
        }
    });
    return map;
};
